import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    // useCancelTranslationRun
    cancelTranslationFailed: 'Не удалось отменить перевод — попробуйте ещё раз',
  },
  en: {
    cancelTranslationFailed: 'Couldn’t cancel the translation — try again',
  },
})
